export const dailyChallengesSelector = (state: any) => state.dailyChallenges;
